export default {"src":"/_next/static/media/505-image.e9e1b6dd.svg","height":325,"width":386,"blurWidth":0,"blurHeight":0};